import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/CatalogBook.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import SearchResults from './pages/SearchResults';
import CatalogBook from './components/CatalogBook';     // добавить импорт
import CatalogDetail from './components/CatalogDetail'; // добавить импорт
import { LanguageProvider } from './components/LanguageContext';

export default function App() {
    return (
        <Router>
            <LanguageProvider>
                <div className="d-flex flex-column min-vh-100">
                    <Header />
                    <main className="flex-grow-1" style={{ paddingTop: '56px' }}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/search" element={<SearchResults />} />
                            <Route path="/catalog" element={<CatalogBook />} />          {/* <- оставляем только CatalogBook */}
                            <Route path="/catalog/:id" element={<CatalogDetail />} />   {/* <- маршрут для карточки */}
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </LanguageProvider>
        </Router>
    );
}
